import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { createPaginationSelector } from 'selectors/filter_dropdown_menu';
import ItemContext from './item_context';
import OtherGroups from './other_groups';
import SelectedGroup from './selected_group';
import ShowMoreGroups from './show_more_groups';
const menuContainerCss = "ml89isy";
const MenuContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuContainerCss, props.className)} />;
});
const listCss = "lufwifx";
const List = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} data-component="menu-container" className={classNames(listCss, props.className)} />;
});
const DefaultItemLabel = ({
  children
}) => children;
const Menu = ({
  className,
  filterName,
  showMoreGroupsLabel,
  onShowMoreItems,
  onShowMoreGroups,
  ItemLabel,
  headerName
}) => {
  const contextValue = useMemo(() => ({
    LabelComponent: ItemLabel || DefaultItemLabel
  }), [ItemLabel]);
  const pagination = useSelector(createPaginationSelector(filterName));
  if (!pagination) {
    return null;
  }
  return <ItemContext.Provider value={contextValue}>
      <MenuContainer className={className}>
        <List>
          <SelectedGroup filterName={filterName} headerName={headerName} />
          <OtherGroups filterName={filterName} onShowMore={onShowMoreItems} />
          <ShowMoreGroups show={Boolean(pagination.next_page)} onClick={onShowMoreGroups} label={showMoreGroupsLabel} />
        </List>
      </MenuContainer>
    </ItemContext.Provider>;
};
export default Menu;

require("./menu.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./menu.js");